import { CurrencyPipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { KENDO_BUTTON, KENDO_BUTTONS, KENDO_CHIP } from '@progress/kendo-angular-buttons';
import { KENDO_CARD, KENDO_GRIDLAYOUT } from '@progress/kendo-angular-layout';
import { AgreementDetailedDto } from '@unity/clients';
import { ChipWorkflowStateSharedComponent } from '@unity/shared/presentation/chip-workflow-state-shared/chip-workflow-state-shared.component';
import { LinkButtonSharedComponent } from '@unity/shared/presentation/link-button-shared/link-button-shared.component';
import { ProgressBarSharedComponent } from '@unity/shared/presentation/progress-bar-shared/progress-bar-shared.component';

@Component({
  selector: 'unity-card-agreement-shared',
  imports: [
    KENDO_CARD,
    KENDO_GRIDLAYOUT,
    KENDO_BUTTON,
    KENDO_BUTTONS,
    KENDO_CHIP,
    CurrencyPipe,
    ChipWorkflowStateSharedComponent,
    ProgressBarSharedComponent,
    LinkButtonSharedComponent,
  ],
  templateUrl: './card-agreement-shared.component.html',
  styleUrl: './card-agreement-shared.component.scss',
})
export class CardAgreementSharedComponent {
  public readonly $agreement = input.required<AgreementDetailedDto>({ alias: 'agreement' });
  public readonly $showAgencyName = input.required<boolean>({ alias: 'showAgencyName' });
}
